module.exports = __webpack_public_path__ + "static/media/not-found.7164c20b.png";